import React from 'react';
import PropTypes from 'prop-types';

// mui
import { Box, Typography } from '@mui/material';

// comps
import { ActionBox } from 'azent-storybook/dist';
import DocumentList from '@/components/shared/DocumentList';

// utils
import {
    getReferenceDocs,
    getCommentDocs,
} from '@/props-constants/application/application-profile';

export default function DocumentsTab({ comments, history, classes }) {
    return (
        <Box className={classes.documentListContainer}>
            <Box mt={3} mb={1} ml={1}>
                <Typography variant="h6">Reference/Supporting Documents</Typography>
                {history && history.length > 0 ? (
                    <DocumentList documents={getReferenceDocs(history)} />
                ) : (
                    <ActionBox
                        subtitle={{
                            text: 'No supporting documents found',
                            variant: 'subtitle1',
                        }}
                        raised={false}
                        elevation={0}
                    ></ActionBox>
                )}
            </Box>

            <Box mt={2} mb={1} ml={1}>
                <Typography variant="h6">Documents from comments</Typography>
                {comments && comments.length > 0 ? (
                    <DocumentList documents={getCommentDocs(comments)} />
                ) : (
                    <ActionBox
                        subtitle={{
                            text: 'No documents from comments found',
                            variant: 'subtitle1',
                        }}
                        raised={false}
                        elevation={0}
                    ></ActionBox>
                )}
            </Box>
        </Box>
    );
}

DocumentsTab.propTypes = {
    comments: PropTypes.array,
    history: PropTypes.array,
    classes: PropTypes.object,
};
